var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

interface Point {
  x: number;
  y: number;
}

// game variables
var middle: Point;
var r = 100;
var r_pos = r;
var v_r = 100; // pixels per second
var hue = 0;

// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var plop = new Audio("plop.wav");

var logo = new Image();
logo.src = "logo.png";

function draw() {
  context.resetTransform();
  context.clearRect(0, 0, width, height);

  // select color
  context.fillStyle = `hsl(${hue}, 50%, 50%)`;

  // draw polygon/path
  context.translate(middle.x, middle.y);
  context.beginPath();
  context.moveTo(0, -r);
  context.lineTo(r_pos, -r_pos);
  context.lineTo(r, 0);
  context.lineTo(r_pos, r_pos);
  context.lineTo(0, r);
  context.lineTo(-r_pos, r_pos);
  context.lineTo(-r, 0);
  context.lineTo(-r_pos, -r_pos);
  context.fill();
  context.resetTransform();

  context.drawImage(logo, 50, 50);
}

function update(dt: number) {
  // radial position
  r_pos += v_r * dt;
  if (r_pos > 1.5 * r) {
    v_r = -v_r;
    r_pos = 1.5 * r;
  } else if (r_pos < 0.1 * r) {
    v_r = -v_r;
    r_pos = 0.1 * r;
  }
  // color
  hue = (hue + 1) % 360;
}

function loop(t_ms: number) {
  // calculate dt
  let dt = t_ms - last_tick_t;
  last_tick_t = t_ms;

  update(dt / 10000); // to seconds
  draw();

  window.requestAnimationFrame(loop);
}

function click(e: MouseEvent) {
  plop.play();
}

function main() {
  canvas = document.querySelector("#canvas") as HTMLCanvasElement;
  context = canvas.getContext("2d")!;
  canvas.addEventListener("click", click);

  width = canvas.width;
  height = canvas.height;
  middle = { x: width / 2, y: height / 2 };

  loop(performance.now());
}

document.addEventListener("DOMContentLoaded", function () {
  main();
});
